var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 0H4.5C2.01825 0 0 2.01825 0 4.5V43.5C0 45.9818 2.01825 48 4.5 48H43.5C45.9818 48 48 45.9818 48 43.5V4.5C48 2.01825 45.9818 0 43.5 0Z",
    fill: "url(#paint0_linear_1040_80)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 9V4.5C48 2.01825 45.9818 0 43.5 0H4.5C2.01825 0 0 2.01825 0 4.5V9H48Z",
    fill: "url(#paint1_linear_1040_80)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6C41.6025 6 41.22 5.8425 40.9425 5.565C40.6575 5.28 40.5 4.8975 40.5 4.5C40.5 4.1025 40.6575 3.72 40.935 3.4425C41.505 2.88 42.5025 2.88 43.0575 3.435C43.3425 3.72 43.5 4.11 43.5 4.5C43.5 4.89 43.3425 5.28 43.065 5.5575C42.78 5.8425 42.3975 6 42 6Z",
    fill: "url(#paint2_linear_1040_80)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 6C37.1025 6 36.72 5.8425 36.435 5.5575C36.1575 5.28 36 4.89 36 4.5C36 4.11 36.1575 3.72 36.435 3.4425C36.9975 2.88 38.0025 2.88 38.565 3.435C38.8425 3.72 39 4.11 39 4.5C39 4.89 38.8425 5.28 38.565 5.5575C38.28 5.8425 37.8975 6 37.5 6Z",
    fill: "url(#paint3_linear_1040_80)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 6C32.6025 6 32.22 5.8425 31.9425 5.5575C31.6575 5.28 31.5 4.8975 31.5 4.5C31.5 4.1025 31.6575 3.72 31.9425 3.4425C32.4975 2.88 33.5025 2.88 34.0575 3.4425C34.3425 3.72 34.5 4.1025 34.5 4.5C34.5 4.8975 34.3425 5.28 34.0575 5.5575C33.78 5.8425 33.3975 6 33 6Z",
    fill: "url(#paint4_linear_1040_80)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.091 22.6215L24.591 18.1215C24.213 17.9595 23.787 17.9595 23.409 18.1215L12.909 22.6215C12.3577 22.8578 12 23.4 12 24C12 24.6 12.3577 25.1423 12.909 25.3785L23.409 29.8785C23.598 29.9595 23.7983 30 24 30C24.2017 30 24.402 29.9595 24.591 29.8785L35.091 25.3785C35.6422 25.1423 36 24.6 36 24C36 23.4 35.6422 22.8578 35.091 22.6215Z",
    fill: "url(#paint5_linear_1040_80)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 36C13.1025 36 12.72 35.8425 12.435 35.5575C12.1575 35.28 12 34.89 12 34.5C12 34.11 12.1575 33.72 12.435 33.4425C13.005 32.88 14.0025 32.88 14.5575 33.4425C14.8425 33.72 15 34.1025 15 34.5C15 34.8975 14.8425 35.28 14.5575 35.5575C14.28 35.8425 13.8975 36 13.5 36Z",
    fill: "url(#paint6_linear_1040_80)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C23.7983 30 23.598 29.9595 23.409 29.8785L16.5 26.9182V33C16.5 35.565 19.7242 37.5 24 37.5C28.2758 37.5 31.5 35.565 31.5 33V26.9182L24.591 29.8793C24.402 29.9595 24.2017 30 24 30Z",
    fill: "url(#paint7_linear_1040_80)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24V30C12 30.828 12.672 31.5 13.5 31.5C14.328 31.5 15 30.828 15 30V26.2748L12.909 25.3785C12.3577 25.1423 12 24.6 12 24Z",
    fill: "url(#paint8_linear_1040_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_80",
    x1: 1.32,
    y1: 46.6808,
    x2: 46.6808,
    y2: 1.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1040_80",
    x1: 10.41,
    y1: 19.41,
    x2: 37.5908,
    y2: -7.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1040_80",
    x1: 40.9387,
    y1: 5.56125,
    x2: 43.062,
    y2: 3.43875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1040_80",
    x1: 36.4395,
    y1: 5.56125,
    x2: 38.5657,
    y2: 3.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1040_80",
    x1: 31.9425,
    y1: 5.5575,
    x2: 34.0575,
    y2: 3.4425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1040_80",
    x1: 17.6895,
    y1: 30.3113,
    x2: 30.3112,
    y2: 17.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1040_80",
    x1: 12.4373,
    y1: 35.559,
    x2: 14.556,
    y2: 33.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1040_80",
    x1: 18.402,
    y1: 36.216,
    x2: 29.6003,
    y2: 25.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1040_80",
    x1: 11.0948,
    y1: 29.7165,
    x2: 14.7675,
    y2: 26.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationWebsite);
export default __webpack_public_path__ + "static/media/education-website.4624f7b66f02515a30cd89fe6eb3adf4.svg";
export { ForwardRef as ReactComponent };